var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('billinglayer2',{key:_vm.key,attrs:{"data":_vm.data,"image":_vm.image}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }